/* eslint-disable unicorn/prefer-spread */
import { IdRouteParameter } from './routes.types';

export const routes = {
  root: '/',
  home: {
    name: 'home',
    get() {
      return routes.root;
    },
  },
  dashboard: {
    name: 'dashboard',
    get() {
      return routes.root.concat(this.name);
    },
    support: {
      name: 'support',
      get() {
        return routes.dashboard.get().concat('/', this.name);
      },
    },
    courses: {
      name: 'courses',
      get() {
        return routes.dashboard.get().concat('/', this.name);
      },
      create: {
        name: 'create',
        get() {
          return routes.dashboard.courses.get().concat('/', this.name);
        },
      },
      courseId: {
        name: ':id',
        get({ id }: IdRouteParameter) {
          return routes.dashboard.courses.get().concat('/', id);
        },
        cards: {
          name: 'cards',
          get({ id }: IdRouteParameter) {
            return routes.dashboard.courses.courseId
              .get({ id })
              .concat('/', this.name);
          },
        },
      },
    },
    students: {
      name: 'students',
      get() {
        return routes.dashboard.get().concat('/', this.name);
      },
      studentId: {
        name: ':id',
        get({ id }: IdRouteParameter) {
          return routes.dashboard.students.get().concat('/', id);
        },
      },
    },
    myProfile: {
      name: 'my-profile',
      get() {
        return routes.dashboard.get().concat('/', this.name);
      },
    },
  },
  embeddedCourses: {
    name: 'courses',
    get() {
      return routes.root.concat(this.name);
    },
    courseId: {
      name: ':id',
      get({ id }: IdRouteParameter) {
        return routes.embeddedCourses.get().concat('/', id);
      },
    },
  },
  callback: {
    name: 'callback',
    get() {
      return routes.root.concat(this.name);
    },
  },
  error: {
    name: 'error',
    get() {
      return routes.root.concat(this.name);
    },
  },
  underConstruction: {
    name: 'under-construction',
    get() {
      return routes.root.concat(this.name);
    },
  },
};
